import React, { useContext, useState, useRef } from "react";
import { Col, Row, Card, Table, Button, Spinner } from "@themesberg/react-bootstrap";
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../components/Pagination'
import { Context } from '../Search'
import TicketDetailModal from "../component/TicketDetailModal";
import ImagePreview from "../../order/partials/image-preview/ImagePreview";

const _Table = () => {

  const { state, dispatch } = useContext(Context);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [modalImageShow, setModalImageShow] = useState(false);
  const selectedImageRef = useRef("");
  const previewTitleRef = useRef("");

  const showImagePreview = (title, image) => {
    previewTitleRef.current = title;
    selectedImageRef.current = image;
    setModalImageShow(true);
  };

  return (
    <>
      <Card border="light" className="shadow-sm border-0">
        <Card.Body className="p-0">
          <Table responsive className="align-items-center table-flush table-hover">
            <thead className="thead-light">
              <tr>
                <th className="border-bottom text-center" scope="col">Ảnh</th>
                <th className="border-bottom text-center" scope="col">Người chơi</th>
                <th className="border-bottom text-center" scope="col">Mã đơn</th>
                <th className="border-bottom text-center" scope="col">Vé</th>
                <th className="border-bottom text-center" scope="col">SL</th>
                <th className="border-bottom text-center" scope="col">Trạng thái</th>
                <th className="border-bottom text-center" scope="col">Ngày mua</th>
                <th className="border-bottom text-center" scope="col">Chi tiết</th>
              </tr>
            </thead>
            <tbody>
              {state.loading && (
                <tr>
                  <td colSpan={8} className="text-center py-4">
                    <Spinner animation="border" size="sm" className="me-2" />
                    Đang tải dữ liệu...
                  </td>
                </tr>
              )}
              {state.data.list &&
                !state.loading &&
                state.data.list.map((pv, index) => (
                  <tr key={`table-keys-lottmekong-${pv.id || index}`}>
                    <TableRow rIndex={index} {...pv} onPreviewImage={showImagePreview} />
                    <td className="text-center">
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => {
                          setSelectedTicket(pv);
                          setShowDetail(true);
                        }}
                      >
                        Xem
                      </Button>
                    </td>
                  </tr>
                ))}
              {(!state.data.list || state.data.list.length === 0) && !state.loading && (
                <tr>
                  <td colSpan={8} className="text-center py-4 text-muted">Không có dữ liệu</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer className="border-0 py-3 bg-light">
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>

      <ImagePreview
        show={modalImageShow}
        title={previewTitleRef.current}
        image={selectedImageRef.current}
        onHide={() => setModalImageShow(false)}
      />

      <TicketDetailModal
        show={showDetail}
        onHide={() => {
          setShowDetail(false);
          setSelectedTicket(null);
        }}
        ticket={selectedTicket}
      />
    </>
  );
};

export default React.memo(_Table)
